<script>
  import { Username, changePasswordThrough ,currentPasswordThrough, SecurityQuestions, SecurityAnswers} from "./store.js";
  import { onMount, createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  import Field from "../FormField.svelte";
  import TextBox from "../HTMLElements/Textbox.svelte";
  import Email from "../HTMLElements/Email.svelte";
  import Phone from "../HTMLElements/PhoneNumber.svelte";
  import Select from "../HTMLElements/Select.svelte";
  import * as Validator from "../Utils/ValidateFormFIelds.js";
	import wrappedFetch from '../../wrappedfetch.js';
  
  let ref = null;
  let hasError = false;
  let error = "";
  let isCapsOn = false;
  let inputValue = '';
  let isLoading = false;

  const email = {value: '', isValid: false, isDirty: false, ref: null };
  const mobile = {value: '', isValid: false, isDirty: false, ref: null };
  const question1 = {value: '', isValid: false, isDirty: false, ref: null };
  const question2 = {value: '', isValid: false, isDirty: false, ref: null };
  let answer1, answer2;
  var obj = {};

  onMount(async function() {
    ref.focus();
    if($Username.value == '' || $Username.value == undefined)
      dispatch('pageChange','/account/forgotpassword');
  });

  const checkCaps = e => {
    if (e.getModifierState && e.getModifierState("CapsLock")) isCapsOn = true;
    else isCapsOn = false;
  };

  const selectOption = (e) => {
    e.preventDefault();
    if($changePasswordThrough == 'password') verifyPassword();
    else if($changePasswordThrough == 'SMS') sendResetSMS();
    else if($changePasswordThrough == 'securityQuestions') verifySecurityAnswers();
    else sendResetEmail(); 
  }


  const sendResetEmail = async () => { 
    obj.email = email;
    email.isDirty = true;   
    if (!Validator.validate(obj)) {
      obj = obj;     
      return;
    }
    isLoading = true;
    var isEmailRegisteredResponse = await wrappedFetch(
      "user/EmailResetPassword?username=" +
        $Username.value +
        "&email=" +
        email.value
    )
      .then(res => res.json())
      .then(result => {
        return result;
      });

    if (isEmailRegisteredResponse.success) dispatch("pageChange", "/account/passwordresetsuccess");
    else {
      hasError = true;
      error = isEmailRegisteredResponse.message;
    }
    isLoading = false;
  }

  const sendResetSMS = async () => {
    obj.mobile = mobile;
    mobile.isDirty = true;   
    if (!Validator.validate(obj)) {
      obj = obj;     
      return;
    }
    isLoading = true;

    var isMobileRegisteredResponse = await wrappedFetch(
      "user/SMSResetPassword?username=" +
        $Username.value +
        "&mobile=" +
        mobile.value
    )
      .then(res => res.json())
      .then(result => {
        return result;
      });
    if (isMobileRegisteredResponse.success) dispatch("pageChange", "/account/passwordresetsuccess");
    else {
      hasError = true;
      error = isMobileRegisteredResponse.message;
    }
    isLoading = false;
  }

  const verifySecurityAnswers = () => {
    isLoading = true;
    if(!question1.value || question1.value == 0 || !question2.value || question2.value == 0 || !answer1 || answer1 == '' || !answer2 || answer2 == '' ){
      hasError = true;
      error = "Please ensure that you have completed the required fields.";
      isLoading = false;
      return;
    }

    if(question1.value == question2.value){
      hasError = true;
      error = "Please answer two different questions."
      isLoading = false;
      return;
    }

    if( $SecurityQuestions.filter(x => x.qRef == question1.value)[0].answer.toLowerCase() == answer1.toLowerCase()  
        &&
        $SecurityQuestions.filter(x => x.qRef == question2.value)[0].answer.toLowerCase() == answer2.toLowerCase() ){

      var ans = [];
      ans.push({"qRef" : question1.value, "answer" : answer1});
      ans.push({"qRef" : question2.value, "answer" : answer2});
      $SecurityAnswers = ans;

      dispatch("pageChange", "/account/createnewpassword");
    }
    else {
      hasError = true;
      error = "One or both answers are incorrect.";
    }
    isLoading = false;
  }

  const verifyPassword = async () => {
    // method: post - because reset password can have wonky characters like &
    var obj = {};
    obj.username = $Username.value;
    obj.password = inputValue;

    isLoading = true;
    const resp = await wrappedFetch('user/matchpassword', {
        method: 'post',
        body: JSON.stringify(obj), 
         headers: {
           'Content-Type': 'application/json'
         }
      });

    var isUserVerified = await resp.json();

    if (isUserVerified) {
      $currentPasswordThrough= inputValue;
      dispatch("pageChange", "/account/createnewpassword");
    }
    else {
      hasError = true;
      error = "Incorrect password.";
    }
    isLoading = false;
  };
</script>

<form action="" class="box">
  <div class=" field">
    <a href="/account/resetoptions">
      <span class="fas fa fa-arrow-left" />
      Back
    </a>
  </div>

  <hr />

  {#if $changePasswordThrough == 'password'}
    <Field label="Enter current password">
      <input
        slot="inputField"
        type="password"
        id="password"
        bind:this={ref}
        bind:value={inputValue}
        placeholder="Current Password"
        on:keyup={checkCaps}
        class="input"
        required />
    </Field>
  {:else if $changePasswordThrough == 'email'}
    <Field label="Enter email address">
      <span slot="inputField">
        <Email
          placeholder="email@domain.com"
          isRequired={true}
          bind:ref
          bind:email={email.value}
          bind:isValid={email.isValid}
          bind:isDirty={email.isDirty}
          label="email address" />
      </span>
    </Field>
  {:else if $changePasswordThrough == 'securityQuestions'}
    <Field label="Answer any two of the security questions which you have previously configured:">
      <span slot="inputField">
        <Select
          items={$SecurityQuestions}
          isRequired="true"
          bind:ref
          bind:selectedValue={question1.value}
          selectedValueText="qRef"
          bind:isValid={question1.isValid}
          bind:isDirty={question1.isDirty}
          label="first security question"
          labelText='question' />
        <br>
        <input
          bind:value={answer1}
          placeholder="Answer to selected question"
          class="input"
          style="margin-top: 10px; max-width: 456px;" 
          required />
          <!-- max-width: fudge for tablets, otherwise input field and select list have mismatched sizes -->
      </span>
    </Field>
      <div style="margin-top: 10px;">
        <Select
          items={$SecurityQuestions}
          isRequired="true"
          bind:selectedValue={question2.value}
          selectedValueText="qRef"
          bind:isValid={question2.isValid}
          bind:isDirty={question2.isDirty}
          label="second security question"
          labelText='question' />
        <br>
        <input
          bind:value={answer2}
          placeholder="Answer to selected question"
          class="input"
          style="margin-top: 10px; max-width: 456px;"
          required />
      </div>
  {:else}
    <Field label="Enter mobile number">
      <span slot="inputField">
        <Phone
          placeholder="07xxx xxxxxx"
          isRequired="true"
          bind:ref
          bind:number={mobile.value}
          bind:isValid={mobile.isValid}
          bind:isDirty={mobile.isDirty}
          isMobile="true"
          label="mobile phone number" />
      </span>
    </Field>
  {/if}

  <hr />
  {#if hasError}
    <div class="notification is-invalid">
      <p class="help" style="margin-bottom:0px">{error}</p>
    </div>
  {/if}
  {#if isCapsOn}
    <p class="help">
      <span class="fas fa fa-exclamation-triangle has-text-warning" />
      CAPS is on!
    </p>
  {/if}
  <div style="text-align: right;">
    <button class="button is-purple {isLoading ? 'is-loading' : ''}" type="submit" on:click={selectOption} disabled={isLoading}>Continue</button>
  </div>
</form>
